// Omnix/client/ui/BrandingKitManager.js
import { ComponentBase } from "../core/ComponentBase.js";
import OmniBrandingKitSchema from "../../schemas/collections/omniBrandingKits.js"; // Import the full schema

export class BrandingKitManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        // --- THIS IS THE FIX ---
        // Create a schema for the FORM by picking only the fields the user can edit.
        // The full schema is still used for the DataView.
        const BrandingKitFormSchema = OmniBrandingKitSchema.pick({
            name: true,
            isDefault: true,
            brandNameShort: true,
            brandNameLong: true,
            logoText: true,
            logoIconClass: true,
            // logoImageUrl is handled by FileUpload, not direct data, so we omit it from schema validation here.
            address: true,
            phone: true,
            email: true,
            website: true,
            socials: true,
            primaryColor: true,
            secondaryColor: true,
            footerText: true
        });
        // --- END OF FIX ---

        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "BrandingKitRpc",
            schemaPath: "collections/omniBrandingKits", // Used for the DataView
            title: "Branding Kits",
            viewConfig: {
                mode: 'grid',
                fields: [
                    {
                        name: 'name',
                        label: 'Kit Name',
                        render: (val, item) => `${val} ${item.isDefault ? '<span class="badge bg-primary">Default</span>' : ''}`
                    },
                    { name: 'brandNameShort', label: 'Short Name' },
                    { name: 'website', label: 'Website' },
                ],
                toolbar: { create: { enabled: true, label: "New Branding Kit" } }
            },
            formConfig: {
                schema: BrandingKitFormSchema, // Use the specific form schema
                fields: {
                    name: { type: 'text', label: 'Kit Name', required: true },
                    isDefault: { type: 'boolean', label: 'Set as Default Kit' },
                    brandNameShort: { type: 'text', label: 'Brand Short Name' },
                    brandNameLong: { type: 'text', label: 'Brand Long Name' },
                    logoText: { type: 'text', label: 'Logo Text (Fallback)' },
                    logoIconClass: { type: 'text', label: 'Logo Icon Class (e.g., bi bi-gem)' },
                    logoImageUrl: {
                        type: 'FileUpload',
                        component: 'FileUpload',
                        label: 'Logo Image',
                        getUploadKey: async () => {
                            return this.appClient.rpcClient.call('BrandingKitRpc.getLogoUploadKey');
                        },
                        autoUpload: true, 
                    },
                    address: { type: 'textarea', label: 'Address' },
                    phone: { type: 'text', label: 'Phone Number' },
                    email: { type: 'email', label: 'Public Email' },
                    website: { type: 'url', label: 'Website URL' },
                    'socials.twitter': { type: 'url', label: 'Twitter URL' },
                    'socials.facebook': { type: 'url', label: 'Facebook URL' },
                    'socials.linkedin': { type: 'url', label: 'LinkedIn URL' },
                    primaryColor: { type: 'color', label: 'Primary Color' },
                    secondaryColor: { type: 'color', label: 'Secondary Color' },
                    footerText: { type: 'textarea', label: 'Footer Text' }
                },
                sections: [
                    { title: "General", fields: ["name", "isDefault"] },
                    { title: "Brand Identity", fields: ["brandNameShort", "brandNameLong", "logoText", "logoIconClass", "logoImageUrl"] },
                    { title: "Contact Info", fields: ["address", "phone", "email", "website"] },
                    { title: "Social Media", fields: ["socials.twitter", "socials.facebook", "socials.linkedin"] },
                    { title: "Appearance", fields: ["primaryColor", "secondaryColor"] },
                    { title: "Content", fields: ["footerText"] }
                ]
            },
            dataConfig: { autoLoad: false }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }
}